import { http } from "./client";
import api from "./axios";

export const fetchReportCatalog = () => http.get("Reports");

export const runReport = ({ reportId, parameters }) => {
    return http.post(`Reports/${reportId}/run`, { parameters });
};

const readContentDispositionFileName = (contentDisposition) => {
    if (!contentDisposition) {
        return "";
    }

    const encodedMatch = contentDisposition.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);

    if (encodedMatch) {
        const encodedFileName = encodedMatch[1].trim().replace(/^"|"$/g, "");

        try {
            return decodeURIComponent(encodedFileName);
        } catch {
            return encodedFileName;
        }
    }

    const fileNameMatch = contentDisposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);

    return (fileNameMatch?.[1] ?? fileNameMatch?.[2] ?? "").trim();
};

const sanitizeFileName = (value) => {
    const invalidCharacters = new Set('<>:"/\\|?*');
    const safeCharacters = Array.from(String(value ?? ""), (character) => {
        const characterCode = character.charCodeAt(0);

        return characterCode <= 31 || characterCode === 127 || invalidCharacters.has(character)
            ? "_"
            : character;
    });

    return safeCharacters.join("")
        .replace(/^\.+/, "")
        .replace(/[. ]+$/, "")
        .trim()
        .slice(0, 180);
};

export const getReportCsvFileName = (contentDisposition, reportId) => {
    const responseFileName = sanitizeFileName(readContentDispositionFileName(contentDisposition));
    const fallbackName = sanitizeFileName(reportId) || "report";
    const fileName = responseFileName || fallbackName;

    return fileName.toLowerCase().endsWith(".csv") ? fileName : `${fileName}.csv`;
};

export const exportReportCsv = async ({ reportId, parameters }) => {
    const response = await api.post(
        `Reports/${encodeURIComponent(reportId)}/export/csv`,
        { parameters },
        { responseType: "blob" }
    );
    const contentDisposition = response.headers?.["content-disposition"];
    const contentType = response.headers?.["content-type"] ?? "text/csv;charset=utf-8";

    return {
        blob: new Blob([response.data], { type: contentType }),
        fileName: getReportCsvFileName(contentDisposition, reportId)
    };
};
